import { call, put, takeLatest } from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import globalErrorHandler from 'react/api/GlobalErrorHandler.js';

export const createCriteriaChain = id => (
  {
    criteriaChain: [
      {
        and: [
          {
            attr: 'closed',
            eq: false,
          },
          {
            attr: 'route.id',
            eq: id,
          },
          {
              "attr": "event.exibitionMode",
              "neq": "NOT_SHOW"
          },
        ],
      },
    ],
    sort: [
      {
        attr: 'timeValuedTrue',
        type: 'DESC',
      },
    ],
  }
);

const url = window.encodeURI('/EventLog/restrictions?criteria={"filters":["*"], "firstResult":0,"maxResults":51}');

export function* prepareSaga({ payload: { id } }) {
  const data = yield call(defaultFetch, url, createCriteriaChain(id), 'POST');
  const { error } = data;
  if (error) {
    yield globalErrorHandler(error);
  } else {
    yield put({
      type: 'GREENMILE_ROUTEMONITOR_EVENT_NOTIFICATION_SUCCESS',
      payload: {
        id,
        data,
      },
    });
  }
}

export default function* routeMonitor() {
  yield takeLatest('GREENMILE_ROUTEMONITOR_EVENT_NOTIFICATION_REQUEST', prepareSaga);
}
